import { createIcon } from './createIcon'

export const DoubleCheckIcon = createIcon({
  displayName: 'DoubleCheckIcon',
  viewBox: '0 0 18 11',
  path: [
    <path
      d="M0.307617 6.05756L4.50012 10.2501L5.55762 9.18506L1.37262 5.00006M16.6801 0.185059L8.74512 8.12756L5.62512 5.00006L4.55262 6.05756L8.74512 10.2501L17.7451 1.25006M13.5001 1.25006L12.4426 0.185059L7.68012 4.94756L8.74512 6.00506L13.5001 1.25006Z"
      fill="currentColor"
    />,
  ],
})
